// extracted by mini-css-extract-plugin
export default {"navBar":"_2HJpjg0N","withBackground":"_35i84LPk"};